import { Box, CircularProgress, Modal, Typography } from "@mui/material"
import React, { useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import useStyles from "./useStyles"

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  height: 225,
  bgcolor: "white",
  p: 3,
  borderRadius: "8px",
  boxShadow: "0px 0px 4px rgba(36, 55, 143, 0.4)",
}

export const ConfirmModal = ({
  openModal,
  handleClose,
  handleConfirmFunction,
  cuit = "",
}) => {
  const classes = useStyles()
  const [showCircularProgress, setShowCircularProgress] = useState(false)
  function formatCUIT() {
    return cuit.toString().length === 11
      ? `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}-${cuit.slice(10)}`
      : ""
  }
  return (
    <>
      <Modal open={openModal} onClose={handleClose}>
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <CloseIcon
              sx={{
                fontSize: "medium",
                color: "#263057",
                // eslint-disable-next-line comma-dangle
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
          </div>

          <div>
            <Typography sx={{ color: "#263057", fontSize: "1.3em" }}>
              Cambiar el estado del CUIT {formatCUIT()}
            </Typography>
          </div>
          <Typography
            sx={{
              color: "#263057",
              fontFamily: "Roboto",
              marginTop: "5%",
            }}
          >
            ¿Esta seguro de que desea cambiar el estado de este CUIT?
          </Typography>

          <Box className={classes.buttons} style={{ marginLeft: "45%" }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              setShowCircularProgress={setShowCircularProgress}
              handleConfirmFunction={handleConfirmFunction}
              handleClose={handleClose}
            />

            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm({
  showCircularProgress,
  setShowCircularProgress,
  handleConfirmFunction,
  // eslint-disable-next-line comma-dangle
  handleClose,
}) {
  // eslint-disable-next-line semi
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = async () => {
    if (!isProgressComplete && !showCircularProgress) {
      setShowCircularProgress(true)
      await handleConfirmFunction()
      setShowCircularProgress(false)
      setProgressComplete(true)
      handleClose()
    }
  }

  return (
    // eslint-disable-next-line quotes
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        className={`${classes.confirmButton} ${
          isProgressComplete ? classes.disabledButton : ""
        }`}
        disabled={isProgressComplete || showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress ? (
          <CircularProgress size="1.5rem" color="inherit" />
        ) : (
          <Typography className={classes.confirmButtonTypography}>
            Aceptar
          </Typography>
        )}
      </button>
    </div>
  )
}

function ButtonClose({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
